import * as React from "react";
import { useContext } from "react";
import { toggleJitKanban } from "./ToggleJitKanban";
import { EditProjectContext } from "../../EditProjectContext";
import { BaseLtlTabView } from "./BaseLtlTabView";
import clearAllRouting from "./ClearAllRouting";
import { ClearAllRoutingsButton } from "./ClearAllRoutingsButton";
import { AddAllActiveRoutingsButton } from "./AddAllActiveRoutingsButton";
import { SetGlobalLtlShipFrequencyButton } from "./SetGlobalLtlShipFrequencyButton";
import { getIdOfSpdrOrPdsr } from "./GetIdOfSpdrOrPdsr";
import { toggleOutOfScope } from "./toggleOutOfScope";
import { isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope } from "./isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope";
import { useHandleLtlTabChange } from "./LtlTabTable/useAddOrUpdateLaunchBatch";
import { ReadOnlyProps } from "../../ReadOnlyProps";

export const LtlTab = ({ isReadOnly }: ReadOnlyProps) => {
  const editProjectContext = useContext(EditProjectContext);
  const { addOrUpdateLaunchBatch } = useHandleLtlTabChange(editProjectContext);
  const { selectedLtlSpdrOrPdsr: spdrOrPdsr, project } = editProjectContext;

  if (!spdrOrPdsr) {
    return <div>No Spdr or Pdsr selected {spdrOrPdsr} </div>;
  }
  const spdrOrPdsrId = getIdOfSpdrOrPdsr(spdrOrPdsr);

  const ltlPipeline = project?.ltlPipelines?.find(
    (p) => p?.SpdrId === spdrOrPdsrId || p?.PdsrId === spdrOrPdsrId
  );

  const ltlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope =
    isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope({
      projectToCheckFor: project,
      selectedLtlPipeline: ltlPipeline,
    });

  return (
    <>
      <BaseLtlTabView
        spdrOrPdsr={spdrOrPdsr}
        ltlPipeline={ltlPipeline}
        toggleJitKanban={() => toggleJitKanban(editProjectContext, spdrOrPdsrId)}
        toggleOutOfScopeSwitch={(checked, pipeline) =>
          toggleOutOfScope({
            editProjectContext,
            outOfScopeChecked: checked,
            ltlPipeline: pipeline,
          })
        }
        handleLaunchBatchChange={addOrUpdateLaunchBatch}
        ltlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope={
          ltlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope
        }
        isReadOnly={isReadOnly}
      />
      <hr style={{ marginTop: "1rem", marginBottom: "1rem" }} />
      <div style={{ display: "flex", alignItems: "end" }}>
        <div style={{ marginRight: "10px" }}>
          <SetGlobalLtlShipFrequencyButton
            isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope={
              ltlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope
            }
            disabled={isReadOnly}
          />
        </div>
        <div style={{ marginRight: "10px", marginBottom: "-5px" }}>
          <AddAllActiveRoutingsButton
            isLtlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope={
              ltlPipelineRoutingEmptyAndSpdrOrPdsrOutOfScope
            }
            disabled={isReadOnly}
          />
        </div>
        <div style={{ marginBottom: "-5px" }}>
          <ClearAllRoutingsButton
            onClick={() => clearAllRouting(editProjectContext)}
            isReadOnly={isReadOnly}
          />
        </div>
      </div>
    </>
  );
};
